/**
 * Help article for a charge that didn't (or won't) reach its charge limit by
 * the Ready By time. Linked from the Charges section's missed-target banner
 * and the Charge Forecast "not enough time" alert.
 */
export const MISSED_CHARGE_TARGET_HELP_URL =
  'https://optiwatt.zendesk.com/hc/en-us/articles/54387588458779-Why-didn-t-my-car-fully-charge'

/**
 * Help article for charging that happened outside the plan's lowest-cost
 * times. Linked from the charge detail page's off-peak banner.
 */
export const WRONG_TIME_CHARGING_HELP_URL =
  'https://optiwatt.zendesk.com/hc/en-us/articles/49246828658075-My-car-charged-at-the-wrong-time-what-happened'
